import { createAxiosClient } from "@ntg/component-library/utilities";
import { useMutation } from "@tanstack/react-query";

const apiClient = createAxiosClient("D365FO");

interface ICommitRouteToManufacturingPayload {
    designID: number;
    mItemID: number;
}

async function commitRouteToManufacturing(
    payload: ICommitRouteToManufacturingPayload,
): Promise<string> {
    const response = await apiClient.post<string>(
        "/FunctionAppsStarter/CommitRouteToManufacturing",
        payload,
    );
    return response.data;
}

export function useCommitRouteToManufacturing() {
    return useMutation({
        mutationFn: commitRouteToManufacturing,
    });
}
